import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import {
  setInitialSearchTerm,
  updateFilter, updateFilterConfig,
} from '@immosky/object-search-filter';
import {
  AppParametersService,
  AppState,
  ResponsiveTarget,
} from '@immosky/types';
import { ObjectSearchAppParameters } from './object-search-app-parameters.service';
import {
  ResponsiveService,
  SessionStorage,
  setIsMapVisible,
} from '@immosky/object-search-layout';
import { UrlParamsSynchronizer } from '../utils/url-params-synchronizer';

@Injectable({
  providedIn: 'root',
})
export class StartupServiceService {
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private appParametersService: AppParametersService<ObjectSearchAppParameters>,
    private responsiveService: ResponsiveService
  ) {}

  start() {
    this.loadAppParameters();
    this.loadFiltersFromUrl();
    this.checkIfShouldDisplayMapInitially();
    this.setupUrlParamsSynchronizer();
  }

  private loadAppParameters() {
    const { initialFilters, countries, isResidia } = this.appParametersService.get();

    if (initialFilters) {
      this.store.dispatch(
        updateFilter({
          contractType: initialFilters.contractType,
          mainCategory: initialFilters.category?.main,
          subcategory: initialFilters.category?.sub,
          price: initialFilters.price,
          roomCount: initialFilters.roomCount,
          livingSpace: initialFilters.livingSpace,
          usageSpace: initialFilters.usageSpace,
          propertySpace: initialFilters.propertySpace,
          countries: countries,
          isResidia: isResidia,
        })
      );

      this.store.dispatch(updateFilterConfig());
    }
  }

  private loadFiltersFromUrl() {
    const actions = UrlParamsSynchronizer.readUrlParams();
    const initialSearchTerm = UrlParamsSynchronizer.readInitialSearchTerm();

    for (const action of actions) {
      this.store.dispatch(action);
    }

    this.store.dispatch(
      setInitialSearchTerm({
        term: initialSearchTerm,
      })
    );
  }

  private checkIfShouldDisplayMapInitially() {
    this.responsiveService.update(); // see BKW-1234
    if (SessionStorage.hasIsMapVisible()) {
      this.setIsMapVisible(SessionStorage.getIsMapVisible());
    } else {
      const isOnDesktop = this.responsiveService.target(
        ResponsiveTarget.LG,
        ResponsiveTarget.XL
      );
      this.setIsMapVisible(isOnDesktop);
    }
  }

  private setIsMapVisible(isVisible: boolean) {
    this.store.dispatch(
      setIsMapVisible({
        isMapVisible: isVisible,
      })
    );
  }

  private setupUrlParamsSynchronizer() {
    this.store.subscribe((state: AppState) => {
      if (UrlParamsSynchronizer.hasReadUrl) {
        UrlParamsSynchronizer.onStateChange(state);
      }
    });
  }
}
